import React from 'react';
import moment from 'moment';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import { TextMessage } from 'components/tt-forms/common';
import { GiaHanDialog, SuspendedDialog, DeleteDialog, ThuHoiDialog } from 'modules/dialog';
import TextTruncate from 'react-text-truncate';
import { CheckPermission } from 'modules/login/CheckPermission';
import { ShowIf } from 'components/utils';
import { CheckQuyenThaoTacXuLy } from 'modules/login/CheckQuyenThaoTacXuLy';
import { CheckCanBoThuHoi } from 'modules/login/CheckCanBoThuHoi';
import { CheckQuyenTuXuLy } from 'modules/login/CheckQuyenTuXuLy';

class RowItemListHandleLetters extends React.Component {

  constructor(props, context) {
    super(props, context);

    this.state = {
      type: this.props.type,
      typeTime: '',
      value: '',
      ketQuaStr: '',
      ketQuaType: '',
      trangThaiDonText: '',
      trangThaiDonType: '',
      canBoXuLy: '',
    }
  }

  getListData() {
    this.props.getListData();
  }

  componentDidMount() {

    if (this.props.item.trangThaiDonInfo) {
      this.props.item.trangThaiDonInfo.filter(item => {
        return item.donViId == this.props.userInfo.donViId;
      }).map((child, i) => {
        if (!this.props.item.ma && child.ketQuaType == 'DINH_CHI') {
          this.setState({
            ketQuaStr: 'Rút đơn',
            ketQuaType: child.ketQuaType,
            trangThaiDonText: child.trangThaiDonText,
            trangThaiDonType: child.trangThaiDonType,
          })
        } else {
          this.setState({
            ketQuaStr: child.ketQuaStr,
            ketQuaType: child.ketQuaType,
            trangThaiDonText: child.trangThaiDonText,
            trangThaiDonType: child.trangThaiDonType,
          })
        }
      })
    }

    if (this.props.item.canBoDangXuLyInfo) {
      this.props.item.canBoDangXuLyInfo.filter(item => {
        return item.donViId == this.props.userInfo.donViId;
      }).map((child, i) => {
        if (child.hoVaTen != "")
          this.setState({
            canBoXuLy: child.hoVaTen
          })
      })
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.type && this.props.type != nextProps.type) {
      this.setState({
        type: nextProps.type
      })
    }
    if (nextProps.item.trangThaiDonInfo) {
      nextProps.item.trangThaiDonInfo.filter(item => {
        return item.donViId == nextProps.userInfo.donViId;
      }).map((child, i) => {
        if (!nextProps.item.ma && child.ketQuaType == 'DINH_CHI') {
          this.setState({
            ketQuaStr: 'Rút đơn',
            ketQuaType: child.ketQuaType,
            trangThaiDonText: child.trangThaiDonText,
            trangThaiDonType: child.trangThaiDonType,
          })
        } else {
          this.setState({
            ketQuaStr: child.ketQuaStr,
            ketQuaType: child.ketQuaType,
            trangThaiDonText: child.trangThaiDonText,
            trangThaiDonType: child.trangThaiDonType,
          })
        }
      })
    }
  }

  showThongTinCongDan() {
    let size = this.props.item.listNguoiDungDon.length;
    if (size) {
      return (
        <div>
          <li className="txt-bold">{this.props.item.listNguoiDungDon[0].hoVaTen}</li>
          <li>{this.getLocal(this.props.item.listNguoiDungDon[0])}</li>
          <li>{this.props.item.listNguoiDungDon[0].soDienThoai}</li>
        </div>
      )
    }
  }

  showThoiHanXuLyDon(ketQuaType = null) {

    let thoiHanXuLy = {};
    if (this.checkDonViTTXM() && this.state.ketQuaType === 'DANG_LAP_DU_THAO') {
      thoiHanXuLy = this.props.item.thoiHanGiaoLapDuThaoInfo
    } else if (ketQuaType != null && ketQuaType === 'DANG_TTXM') {
      thoiHanXuLy = this.props.item.thoiHanTTXMInfo;
    } else if (this.props.item.thongTinGiaiQuyetDonInfo && this.props.item.thongTinGiaiQuyetDonInfo.ngayBatDauKTDX) {

      thoiHanXuLy = this.props.item.thoiHanKTDXInfo;
    } else {
      if (this.props.item.donViThamTraXacMinhInfo && this.props.item.donViThamTraXacMinhInfo.coQuanQuanLyId == this.props.userInfo.donViId) {

        thoiHanXuLy = this.props.item.thoiHanTTXMInfo;
      } else if (this.props.item.donViXuLyGiaiQuyetInfo && this.props.item.donViXuLyGiaiQuyetInfo.coQuanQuanLyId == this.props.userInfo.donViId) {

        this.props.item.trangThaiDonInfo.filter(item => {
          return item.donViId == this.props.userInfo.donViId;
        }).map((child, i) => {

          if (child.trangThaiDonType === 'DANG_XU_LY')
            thoiHanXuLy = this.props.item.thoiHanXuLyInfo;
          if (child.trangThaiDonType === 'DANG_GIAI_QUYET')
            thoiHanXuLy = this.props.item.thoiHanGiaiQuyetInfo;
        });
      }
    }

    if (thoiHanXuLy.type === 'DAY') {

      if (thoiHanXuLy.value == 0) {
        return (
          <p style={{ color: "#E9573F" }}>Hết hạn</p>
        )
      } else if (thoiHanXuLy.value > 0) {
        return (
          <p>Còn {thoiHanXuLy.value} ngày</p>
        )
      } else {
        return (
          <p style={{ color: "#E9573F" }}>Trễ {Math.abs(thoiHanXuLy.value)} ngày</p>
        )
      }
    } else if (thoiHanXuLy.type === 'TIME') {
      return (
        <p style={{ color: "#E9573F" }}>Còn {thoiHanXuLy.value}</p>
      )
    }
  }

  showCanBoDangXuLy() {
    let state = this.state;
    this.props.item.canBoDangXuLyInfo.filter(item => {
      return item.donViId == this.props.userInfo.donViId;
    }).map((child, i) => {
      state.canBoXuLy = child.hoVaTen || '';
    })
    this.setState(state);
  }

  checkNguonDon(type) {
    let userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
    let nguonDonText = '';
    let nguonDonDonVi = '';
    let nguonDontype = '';
    let Return = '';
    if (this.props.item.nguonDonInfo && this.props.item.nguonDonInfo.length > 0) {
      let dataNguonDon = this.props.item.nguonDonInfo.filter(nguonDon => {
        return nguonDon.idDonVi == userInfo.donViId;
      });

      if (dataNguonDon.length > 0) {
        nguonDonText = dataNguonDon[0].nguonDonText;
        nguonDonDonVi = dataNguonDon[0].donViChuyenText;
        nguonDontype = dataNguonDon[0].type;
      } else {
        nguonDonText = this.props.item.nguonDonText;
        nguonDonDonVi = '';
        nguonDontype = '';
      }
    }
    if (type === 'nguonDonText') {
      Return = nguonDonText
    }
    if (type === 'nguonDonDonVi') {
      Return = nguonDonDonVi
    }
    if (type === 'nguonDontype') {
      Return = nguonDontype
    }
    return Return;
  }

  showThoiHanLapDuThao() {
    let thoiHanXuLy = null;
    if (typeof this.props.item === 'object' && this.props.item.thoiHanGiaoLapDuThaoInfo) {
      thoiHanXuLy = this.props.item.thoiHanGiaoLapDuThaoInfo;
    }
    if (thoiHanXuLy && thoiHanXuLy.type === 'DAY') {

      if (thoiHanXuLy.value == 0) {
        return (
          <p style={{ color: "#E9573F" }}>Hết hạn</p>
        )
      } else if (thoiHanXuLy && thoiHanXuLy.value > 0) {
        return (
          <p>Còn {thoiHanXuLy.value} ngày</p>
        )
      } else {
        return (
          <p style={{ color: "#E9573F" }}>Trễ {Math.abs(thoiHanXuLy.value)} ngày</p>
        )
      }
    } else if (thoiHanXuLy && thoiHanXuLy.type === 'TIME') {
      return (
        <p style={{ color: "#E9573F" }}>Còn {thoiHanXuLy.value}</p>
      )
    }
  }

  checkDonViTTXM() {
    let userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
    if (this.props.item.donViThamTraXacMinhInfo && this.props.item.donViThamTraXacMinhInfo.coQuanQuanLyId == userInfo.donViId) {
      return true
    } else {
      return false
    }
  }
  getLocal(data) {
    let address = [];
    if(data) {
      if(data.diaChi) {
        address.push(data.diaChi);
      }
      if(data.toThon) {
        address.push(data.toThon);
      }
      if(data.phuongXaCongDan && data.phuongXaCongDan.ten) {
        address.push(data.phuongXaCongDan.ten);
      }
      if(data.quanHuyenCongDan && data.quanHuyenCongDan.ten) {
        address.push(data.quanHuyenCongDan.ten);
      }
      if(data.tinhThanhCongDan && data.tinhThanhCongDan.ten) {
        address.push(data.tinhThanhCongDan.ten);
      }
    }
    return address.join(", ");
  }

  checkDonKTDX() {
    if (this.props.item.thongTinGiaiQuyetDonInfo && this.props.item.thongTinGiaiQuyetDonInfo.ngayBatDauKTDX) {
      return true
    } else {
      return false
    }
  }

  checkQuyenBoSungThongTin() {
    let data = [...this.props.item.listLichSuCanBoXuLy];
    let userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
    let dataCheck = data.filter(state => {
      return state.congChucId == userInfo.id
    })

    if(dataCheck.length > 0) {
      return true;
    } else {
      return false;
    }
  }

  componentDidUpdate(previewProps) {
    if(previewProps.item !== this.props.item) {
      this.showCanBoDangXuLy();
    }
  }

  render() {
    let donId = this.props.item.donId;
    let linkToDetailPage = '/chi-tiet-xu-ly-don/xem/'+ (this.props.type == 'DANG_XU_LY' ? 'dang/' : 'da/') + donId;
    let linkToProcessPage = '/chi-tiet-xu-ly-don/xu-ly/'+ (this.props.type == 'DANG_XU_LY' ? 'dang/' : 'da/') + donId;
    let donDate = this.props.item.ngayTiepNhan ? moment(this.props.item.ngayTiepNhan).format('DD/MM/YYYY') : '';
    let donTime = this.props.item.ngayTiepNhan ? moment(this.props.item.ngayTiepNhan).format('HH:mm') : '';
    let nguonDonText = this.checkNguonDon('nguonDonText');
    let nguonDonDonVi = this.checkNguonDon('nguonDonDonVi');
    let nguonDontype = this.checkNguonDon('nguonDontype');
    let userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
    let showDelete = this.props.item.nguoiTaoId === userInfo.id;
    let trangThaiDon = '';
    if (typeof this.props.item === 'object' && this.props.item.trangThaiDonInfo) {
      trangThaiDon = this.props.item.trangThaiDonInfo.filter(state => {
        return state.donViId == userInfo.donViId
      });
    }
    let ThamSo = localStorage.getItem('thamSo') ? JSON.parse(localStorage.getItem('thamSo')) : [];
    let CQQLBanTiepCongDan = ThamSo.find(item => item.ten === 'CQQL_BAN_TIEP_CONG_DAN');
    let CQQLPhongNoiChinh = ThamSo.find(item => item.ten === 'CQQL_BAN_NOI_CHINH_THANH_UY');

    return (
      <tr>

        <td>{this.props.count}</td>

        <td>{this.props.item.ma || this.props.item.maHoSo}</td>

        <td>
          <ul className="list-items-table">
            <li>{donDate}</li>
            <li>{donTime}</li>
          </ul>
        </td>

        <td>
          <ul className="list-items-table">
            {this.showThongTinCongDan()}
          </ul>
        </td>

        <td>
          <ul className="list-items-table">
            <li>
              <ShowIf condition={!CheckQuyenThaoTacXuLy(this.props.item.canBoDangXuLyInfo)}>
              {
                this.props.donTreHanTaiDiaBan ?
                <TextTruncate
                  line={3}
                  truncateText="…"
                  text={this.props.item.noiDung}
                /> :
                <Link
                  className="txt-underline"
                  to={linkToDetailPage} >
                  <TextTruncate
                    line={3}
                    truncateText="…"
                    text={this.props.item.noiDung}
                  />
                </Link>
              }
              </ShowIf>
              <ShowIf condition={CheckQuyenThaoTacXuLy(this.props.item.canBoDangXuLyInfo)}>
                <Link
                  className="txt-underline"
                  to={linkToDetailPage} >
                  <TextTruncate
                    line={3}
                    truncateText="…"
                    text={this.props.item.noiDung}
                  />
                </Link>
              </ShowIf>
            </li>
            <ShowIf condition={
              (!this.checkDonViTTXM() || (trangThaiDon && trangThaiDon.length > 0 && trangThaiDon[0].ketQuaType != 'DA_CO_KET_QUA_TTXM' && trangThaiDon[0].ketQuaType != 'DA_CO_KET_QUA_TTXM_LAI')) &&
              (!this.checkDonViTTXM() || (trangThaiDon && trangThaiDon.length > 0 && trangThaiDon[0].ketQuaType != 'DA_LAP_DU_THAO')) &&
              (trangThaiDon && trangThaiDon.length > 0 && trangThaiDon[0].ketQuaType !='LUU_HO_SO')
            }>
              <li>{this.showThoiHanXuLyDon()}</li>
            </ShowIf>
            <li>{this.props.item.lyDoQuaHan}</li>
          </ul>
        </td>

        <td>
          <ul className="list-items-table">
            <li>
              {this.props.item.loaiDonInfo ? this.props.item.loaiDonInfo.ten : ''}
            </li>
            <li>{this.props.item.soNguoi ? (this.props.item.soNguoi + ' người') : ''}</li>
          </ul>
        </td>

        <td>
          <ul className="list-items-table">
            <ShowIf condition={nguonDonDonVi != '' && nguonDonDonVi != null}>
              <li className="txt-italic">{nguonDonDonVi}</li>
            </ShowIf>
            <li>{nguonDonText}</li>
          </ul>
        </td>
        <td>{this.props.item.coQuanDaGiaiQuyetDonThu || ''}</td>

        <td>
          <ul className="list-items-table">
            <ShowIf condition={this.state.trangThaiDonText != null && this.state.trangThaiDonText != ''}>
              <li>{this.state.trangThaiDonText}</li>
            </ShowIf>
            <ShowIf condition={this.state.ketQuaStr != null && this.state.ketQuaStr != ''}>
              <li>
                <TextMessage className='txt-italic col-100 no-gutter txt-left' value={this.state.ketQuaStr || ''}/>
              </li>
            </ShowIf>
            <ShowIf condition={this.state.ketQuaType === 'DANG_TTXM' && !this.checkDonViTTXM()}>
              <li>
                <p className="">
                  {this.showThoiHanXuLyDon(this.state.ketQuaType)}
                </p>
              </li>
            </ShowIf>
            <ShowIf condition={this.state.ketQuaType === 'DANG_LAP_DU_THAO' && !this.checkDonViTTXM()}>
              <li>{this.showThoiHanLapDuThao()}</li>
            </ShowIf>
          </ul>
        </td>

        <td>{this.state.canBoXuLy}</td>

        <td>
          <div className="todo-wrap two-item">

            {/* Button: TU XU LY */}
            <ShowIf condition={
              this.props.tuXuLy &&
              CheckPermission('XULYDON_SUA') &&
              (this.props.type === 'DA_XU_LY') &&
              CheckQuyenTuXuLy(this.props.item.quyenTuXuLyInfo)
              }>
              <div className="wrap-link-todo">
                <Link className="itt-redirect" to={linkToProcessPage}>Tự xử lý</Link>
              </div>
            </ShowIf>

            {/* Button: XU LY */}
            <ShowIf condition={
              CheckPermission('XULYDON_SUA') &&
              (this.props.type === 'DANG_XU_LY') &&
              CheckQuyenThaoTacXuLy(this.props.item.canBoDangXuLyInfo)}>
              <div className="wrap-link-todo">
                <Link className="itt-redirect" to={linkToProcessPage}>Xử lý</Link>
              </div>
            </ShowIf>

            {/* Button: Bổ sung */}
            <ShowIf condition={
              (CQQLBanTiepCongDan.giaTri === userInfo.coQuanQuanLyId || CQQLPhongNoiChinh.giaTri === userInfo.coQuanQuanLyId) &&
              this.props.item.huongXuLyXLD === "CHUYEN_DON" &&
              this.props.type === 'DA_XU_LY' &&
              userInfo.isBoSungThongTin === true
            }>
              <div className="wrap-link-todo"><Link className="itt-redirect" to={'/bo-sung-thong-tin-chuyen-don/' + this.props.item.donId}>Bổ sung</Link></div>
            </ShowIf>

            {/* Button: THU HOI */}
            <ShowIf condition={CheckCanBoThuHoi(this.props.item.canBoCoTheThuHoiInfo)}>
              <ThuHoiDialog
                title={'Xác nhận'}
                redux={this.props.parent}
                donId={this.props.item.donId}
                thongTinGiaiQuyetDonId={this.props.item.thongTinGiaiQuyetDonId || ''}
                getListData={this.getListData.bind(this)}
              />
            </ShowIf>

            <ShowIf condition={
              this.props.item.huongXuLyXLD != 'DINH_CHI' &&
              nguonDontype != 'GIAO_TTXM' &&
              !this.props.item.dangGiaoKTDX &&
              !this.props.item.hoanThanhDon &&
              !this.props.item.daGiaiQuyet &&
              !this.checkDonKTDX() &&
              (this.props.item.loaiDon == 'DON_TO_CAO') &&
              this.props.item.processType != null &&
              this.props.item.processType != 'XU_LY_DON' &&
              this.state.trangThaiDonType !='DA_GIAI_QUYET' &&
              (this.props.item.donViXuLyGiaiQuyetInfo && userInfo.donViId == this.props.item.donViXuLyGiaiQuyetInfo.coQuanQuanLyId)}>
              <GiaHanDialog id={donId}
                thongTinGiaiQuyetDonId={this.props.item.thongTinGiaiQuyetDonId}
                loaiDon={this.props.item.loaiDon}
                getListData={this.getListData.bind(this)} />
            </ShowIf>

            {/* Button: RUT DON / DINH CHI */}
            <ShowIf condition={
              CheckPermission('XULYDON_SUA') &&
              !this.props.item.hoanThanhDon &&
              !this.props.item.daGiaiQuyet &&
              !this.checkDonKTDX() &&
              (nguonDontype != 'GIAO_TTXM' && !this.props.item.dangGiaoKTDX) &&
              this.props.item.processType != 'THEO_DOI_THUC_HIEN' &&
              this.props.item.loaiDon != 'DON_KIEN_NGHI_PHAN_ANH' &&
              !this.props.item.ma &&
              !this.props.donTreHanTaiDiaBan}>
              <SuspendedDialog loaiDon={this.props.item.loaiDon} trangThaiDon={this.state.trangThaiDonType} type="XU_LY_DON" id={donId} getListData={this.getListData.bind(this)} />
            </ShowIf>

            {/* Button: DELETE
                (!this.props.item.lanhDaoDuyet &&
                  this.props.item.processType === 'XU_LY_DON' &&
                  !this.props.item.hoanThanhDon &&
                  !this.props.item.huongXuLyXLD &&
                  this.props.item.tongSoLuotTCD == 0 &&
                  CheckQuyenThaoTacXuLy(this.props.item.canBoDangXuLyInfo))
            */}
            <ShowIf condition={CheckPermission('XULYDON_XOA') && showDelete}>
              <DeleteDialog
                title={'Xoá đơn thư'}
                content={'Bạn có đồng ý xóa đơn thư này không?'}
                redux={this.props.parent}
                deleteId={this.props.item.donId}
              />
            </ShowIf>
            <ShowIf condition= {
              this.props.type === 'DA_XU_LY' &&
              this.props.item.huongXuLyXLD != 'DINH_CHI' &&
              this.checkQuyenBoSungThongTin &&
              this.state.ketQuaType =='LUU_HO_SO'}>
              <div className="wrap-link-todo"><Link className="itt-redirect" to={'/bo-sung-thong-tin-xu-ly-don/' + this.props.item.donId}>Bổ sung thông tin</Link></div>
            </ShowIf>

          </div>
        </td>
      </tr>
    )
  }
}

RowItemListHandleLetters.defaultProps = {
  dataLoaiDonThu: [],
  tuXuLy: false
}

let bindStateToProps = state => {
  return {
    userInfo: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {},
    dataLoaiDonThu: state.duLieuHeThong.loaiDonThu
  }
}

export default connect(bindStateToProps)(RowItemListHandleLetters);



// WEBPACK FOOTER //
// ./src/components/modules/handle-letters/datatable/list/RowItemListHandleLetters.jsx